import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"460px"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "",
  style: {}
}
const _hoisted_6 = {
  class: "title text-left mt10 pad10",
  style: {}
}
const _hoisted_7 = {
  class: "fs22 fl w90",
  style: {"color":"#696969","line-height":"28px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  class: "text pad10",
  style: {"color":"#696969"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "w100",
  style: {}
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "fl fs16 arial" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { class: "w100 mt10" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "fl fs12 mt3 ddgrey w80" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "w100 mt10",
  style: {}
}
const _hoisted_22 = { class: "fl mr15 ml15" }
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 0,
  class: "fl mt10 w90"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 1,
  class: "fl mt10 w90"
}
const _hoisted_27 = {
  key: 2,
  class: "fl w90",
  style: {"margin-left":"50px"}
}
const _hoisted_28 = ["href"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = {
  key: 2,
  class: "mt20"
}
const _hoisted_31 = { class: "fl mr15 ml15" }
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 0,
  class: "fl ddgrey fs13 kaigyo mt10 w90",
  style: {"line-height":"1.4"}
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["href", "onClick"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = {
  key: 3,
  class: "ml15 fw600 skyblue underline mt20"
}
const _hoisted_40 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "CalendarEventDetailModal",
    "content-class": "rad10 with_white_bg shadowContent modalStandard noscroll ofs",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideFixScheduleModal && _ctx.hideFixScheduleModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        (_ctx.ev)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", {
                  class: _normalizeClass(`fs22 fl ml15 mr15 `),
                  style: _normalizeStyle({
                            color: _ctx.rm.userInfo ? `#${_ctx.rm.userInfo.color}` : ``,
                        })
                }, " ■ ", 4),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.ev.title), 1),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                (_ctx.ev.start_time)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/logo/menu_icon03.png`),
                        class: "fl mr15 ml15",
                        style: {"width":"18px","height":"18px"}
                      }, null, 8, _hoisted_12),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.dateFormat()), 1),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_15,
                _withDirectives(_createElementVNode("div", _hoisted_16, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_circle.png`),
                    width: "14",
                    height: "15",
                    class: "fl mt2 mr16 ml17"
                  }, null, 8, _hoisted_17),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.calendarName), 1),
                  _hoisted_19
                ], 512), [
                  [_vShow, _ctx.calendarName]
                ]),
                _hoisted_20,
                (_ctx.ev.location)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/logo/menu_icon04.png`),
                          style: {"margin-top":"10px","width":"18px","height":"18px"}
                        }, null, 8, _hoisted_23)
                      ]),
                      (_ctx.Util.isUrl(_ctx.ev.location))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("a", {
                              href: _ctx.ev.location,
                              class: "fs12",
                              target: "_blank"
                            }, _toDisplayString(_ctx.ev.location), 9, _hoisted_25)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.ev.location), 1)),
                      (_ctx.ev.is_online_meeting)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                            _createElementVNode("a", {
                              class: "fs11 skyblue underline",
                              href: `${_ctx.ev.online_meeting_url}`,
                              target: "_blank",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickOnlineMeeting && _ctx.clickOnlineMeeting(...args)))
                            }, _toDisplayString(_ctx.ev.online_meeting_url), 9, _hoisted_28)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_29,
                (_ctx.Util.isPresent(_ctx.ev.description))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/logo/text_icon.png`),
                          style: {"margin-top":"10px","width":"18px","height":"18px"}
                        }, null, 8, _hoisted_32)
                      ]),
                      (_ctx.Util.isPresent(_ctx.ev.description))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoLink, (text, textindex) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: `${text}${textindex}`
                              }, [
                                (text.match(_ctx.regex))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                      _createElementVNode("a", {
                                        href: text,
                                        class: _normalizeClass(`innerLink underline skyblue`),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        style: {"text-decoration":"underline"},
                                        onClick: ($event: any) => (_ctx.clickInnerDescription(text))
                                      }, _toDisplayString(text), 9, _hoisted_35)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(text), 1))
                              ]))
                            }), 128)),
                            _hoisted_37
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_38,
                (_ctx.Util.isPresent(_ctx.ev.parent_room_url))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("a", {
                        href: _ctx.ev.parent_room_url,
                        target: "_blank",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goRoom && _ctx.goRoom(...args)))
                      }, "調整ページへ", 8, _hoisted_40)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}